import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { FolderKanban, Trash2, Plus } from "lucide-react";

const COLORS = ["#4E9BEE", "#15803D", "#B91C1C", "#D97706", "#7C3AED", "#0E7490"];

export default function Projects() {
  const [projects, setProjects] = useState([]);
  const [name, setName] = useState("");
  const [color, setColor] = useState(COLORS[0]);

  const load = () => api.get("/projects").then(({ data }) => setProjects(data)).catch(() => {});
  useEffect(() => {
    load();
  }, []);

  const create = async () => {
    if (!name.trim()) {
      toast.error("Укажите название проекта");
      return;
    }
    try {
      await api.post("/projects", { name: name.trim(), color });
      setName("");
      toast.success("Проект создан");
      load();
    } catch {
      toast.error("Не удалось создать проект");
    }
  };

  const remove = async (id) => {
    try {
      await api.delete(`/projects/${id}`);
      toast.success("Проект удалён");
      load();
    } catch {
      toast.error("Не удалось удалить проект");
    }
  };

  return (
    <div data-testid="projects-page">
      <h1 className="text-2xl font-bold text-slate-900 mb-1">Проекты</h1>
      <p className="text-sm text-slate-500 mb-5">Группируйте документы по проектам или направлениям бизнеса</p>

      <div className="bg-white border border-slate-200 rounded-xl p-4 mb-5 flex flex-wrap items-center gap-3">
        <Input
          placeholder="Название проекта"
          value={name}
          onChange={(e) => setName(e.target.value)}
          data-testid="new-project-name-input"
          className="max-w-xs"
        />
        <div className="flex gap-1.5">
          {COLORS.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => setColor(c)}
              data-testid={`project-color-swatch-${c.replace("#", "")}`}
              style={{ backgroundColor: c }}
              className={`w-6 h-6 rounded-full ring-2 transition-all ${color === c ? "ring-slate-900 scale-110" : "ring-transparent"}`}
            />
          ))}
        </div>
        <Button onClick={create} data-testid="create-project-button" className="bg-slate-900 hover:bg-slate-800">
          <Plus className="w-3.5 h-3.5 mr-1.5" />Создать проект
        </Button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {projects.map((p) => (
          <div key={p.id} className="bg-white border border-slate-200 rounded-xl p-4 flex items-center justify-between" data-testid={`project-card-${p.id}`}>
            <div className="flex items-center gap-2.5">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${p.color}1A` }}>
                <FolderKanban className="w-4 h-4" style={{ color: p.color }} />
              </div>
              <span className="font-medium text-slate-800">{p.name}</span>
            </div>
            <Button size="icon" variant="ghost" onClick={() => remove(p.id)} data-testid={`delete-project-button-${p.id}`}>
              <Trash2 className="w-3.5 h-3.5 text-slate-400" />
            </Button>
          </div>
        ))}
        {projects.length === 0 && (
          <div className="col-span-full text-center text-slate-400 text-sm py-10" data-testid="projects-empty-state">
            Проектов пока нет
          </div>
        )}
      </div>
    </div>
  );
}
